import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';

import DownloadIcon from '@mui/icons-material/VerticalAlignBottom';

import { massActionCsvExport } from 'src/reducers/massAction';
import { useAlert } from 'src/hooks';

const CsvExportButton = ({ doExport }) => {
  const { showAlert } = useAlert();
  const { t } = useTranslation();

  return (
    <Tooltip title={t('smartmessaging.massAction.navButton.csvExport')}>
      <IconButton
        aria-label="clear"
        onClick={e => {
          e.preventDefault();
          doExport(showAlert);
        }}
        color="secondary"
        size="large"
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  );
};

CsvExportButton.propTypes = {
  doExport: PropTypes.func.isRequired,
};

const actionCreators = { doExport: massActionCsvExport };

export default connect(null, actionCreators)(CsvExportButton);
